// src/client.ts
import { createThirdwebClient } from "thirdweb";

export const client = createThirdwebClient({
  clientId: '8018c7a63d37f038f9e2097ace35b324',
});
//5a848d9643ca14e2f431ee7aee44d0ce